import { render, staticRenderFns } from "./WashingListForm.vue?vue&type=template&id=5f64d3f9&"
import script from "./WashingListForm.vue?vue&type=script&lang=ts&"
export * from "./WashingListForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports